import appModuleRegistry from "components/appModules/appModuleRegistry";
import { LocalStorage } from "components/appModules/LocalStorage";
import { Component, ComponentDefinition } from "components/components/Component";
import i18n from "components/i18n/i18n";
import Language from "components/language_selector/language";
import sislogUserGlobals from "components/UserGlobals";
import $ from "jquery";
import { Router } from "../router/router";
import template from "./login.hbs";
import "./login.scss";

export class Login implements Component {
    public componentType = "login";
    public id: string;
    public definition: LoginComponentDefinition;
    private view: Element;
    private model: { username: string, password: string } = {
        username: "",
        password: "",
    };
    private enabled: boolean;

    constructor(definition: LoginComponentDefinition) {
        this.definition = definition;
    }

    public render() {
        let d = document.createElement("div");
        this.model.username = LocalStorage.getLogin();
        d.innerHTML = template(Object.assign(
            this.definition,
            {
                destinationEncoded: encodeURI(this.definition.destination),
                languages: this.loadLanguages(),
                uid: this.model.username,
                notuidMessage: {
                    key: "login.changeUser",
                },
            },
        ));
        this.view = d.firstChild as Element;
        (this.view.getElementsByClassName("c-login__password-change-optional")[0] as HTMLElement)
            .style.display = "none";
        (this.view.getElementsByClassName("c-login__password-change-required")[0] as HTMLElement)
            .style.display = "none";
        (this.view.getElementsByClassName("c-login__button-return-button")[0] as HTMLElement)
            .style.display = "none";
        if (this.definition.mode !== "overlay") {
            this.view.getElementsByClassName("c-login__user-input")[0].addEventListener("keyup", (evt) => {
                this.model.username = (evt.target as HTMLInputElement).value;
                this.enableIfFilled();
            });
        }
        if (this.model.username != null && this.definition.mode !== "overlay") {
            this.view.getElementsByClassName("c-login__user-label-notuid")[0].addEventListener("click", (evt) => {
                // LocalStorage.clearUser();
                this.view.getElementsByClassName("c-login__user-label")[0].classList.add("c-login__user-label--hidden");
                this.view.getElementsByClassName("c-login__user")[0].classList.remove("c-login__user--hidden");
            });
        }
        this.view.getElementsByClassName("c-login__password-input")[0]
            .addEventListener("keyup", this.passwordChangedCallback);
        this.view.getElementsByClassName("c-login__password-input")[0]
            .addEventListener("change", this.passwordChangedCallback);
        this.view.getElementsByClassName("c-login__button-button")[0]
            .addEventListener("click", this.loginClickListener);
        this.view.getElementsByTagName("form")[0].addEventListener("keyup", this.enterKeyCallback);
        this.disable();
        return this.view;
    }

    private enterKeyCallback = (event) => {
        if (!this.enabled) {
            return;
        }
        // Cancel the default action, if needed
        event.preventDefault();
        // Number 13 is the "Enter" key on the keyboard
        if (event.keyCode === 13) {
            // Trigger the button element with a click
            this.loginClickListener(event);
        }
    }

    private passwordChangedCallback = (evt) => {
        this.model.password = (evt.target as HTMLInputElement).value;
        this.enableIfFilled();
    }

    private loadLanguages(): Language[] {
        let languages = [];
        i18n.getLanguages().forEach((code) => languages.push({
            code,
            key: "language." + code,
            native: "language_native." + code,
        }));
        return languages;
    }

    private loginClickListener = (evt) => {
        // for now let's get the first registered app
        let url = appModuleRegistry.apps[0].baseUrl;
        this.setLoading();
        fetch(url + "/login", {
            method: "POST",
            credentials: "include",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(this.model),
        })
            .then((response) => {
                return response.json();
            }).then((json) => {
                if (json != null && json.userId != null && json.resultId === "0") {
                    LocalStorage.setLogin(json.userName, json.userId, this.model.username);
                    let lang;
                    if (json.userLang != null && !sislogUserGlobals.languageSet) {
                        sislogUserGlobals.language = json.userLang
                        lang = json.userLang;
                    } else {
                        lang = sislogUserGlobals.language;
                    }

                    i18n.instance.changeLanguage(lang, () => {
                        if (this.definition.destination != null) {
                            Router.getInstance().navigate(this.definition.destination);
                        } else {
                            this.definition.callback();
                        }
                        $(document).trigger("loggedIn", [this]);
                    });
                } else {
                    this.fail(json);
                }
                this.unsetLoading();
            }).catch((ex) => {
                this.unsetLoading();
                this.fail(null);
                console.error("parsing failed", ex);
            });
    }

    private setLoading() {
        this.disable();
        this.view.getElementsByTagName("i").item(0).classList.add("fa-circle-o-notch");
        this.view.getElementsByTagName("i").item(0).classList.add("fa-spin");
    }
    public unsetLoading() {
        this.enable();
        this.view.getElementsByTagName("i").item(0).classList.remove("fa-circle-o-notch");
        this.view.getElementsByTagName("i").item(0).classList.remove("fa-spin");
    }

    private fail(json) {
        if (json != null && json.resultId === "expiredPassword") {
            LocalStorage.setLogin(json.userName, json.userId, this.model.username);
            (window as any).formatPass = json.formatPass;
            Router.getInstance().navigate("/expiredPassword?destination=" + this.definition.destination);
        } else {
            this.view.classList.add("c-login--failed");
            if (json != null && json.resultId === "-1") {
                this.view.getElementsByClassName("c-login__error-message")[0].innerHTML
                    = i18n.instance.t("login.dataError");
            } else {
                this.view.getElementsByClassName("c-login__error-message")[0].innerHTML
                    = i18n.instance.t("login.loginError");
            }
            setTimeout(() => this.view.classList.remove("c-login--failed"), 820);
        }
    }

    private enableIfFilled() {
        if (this.model.username != null && this.model.username.length > 0
            && this.model.password != null && this.model.password.length > 0) {
            this.enable();
        } else {
            this.disable();
        }
    }
    public disable() {
        this.enabled = false;
        let btn = (this.view as HTMLElement).querySelector(".c-login__button-button");
        btn.classList.add("is-disabled");
        btn.setAttribute("aria-disabled", "true");
        btn.removeEventListener("click", this.loginClickListener);
    }

    public enable() {
        this.enabled = true;
        let btn = (this.view as HTMLElement).querySelector(".c-login__button-button");
        btn.classList.remove("is-disabled");
        btn.removeAttribute("aria-disabled");
        btn.addEventListener("click", this.loginClickListener);
    }

    public postRender() {
        if (document.getElementById("c-login__user-input").offsetParent === null) {
            setTimeout(() => document.getElementById("c-login__password-input").focus(), 0);
        } else {
            setTimeout(() => document.getElementById("c-login__user-input").focus(), 0);
        }
    }
}

export interface LoginData {
    uid?: string;
}

export interface LoginComponentDefinition extends ComponentDefinition {
    url: string;
    mode: string;
    destination?: string;
    callback?: () => void;
}
